import { useNavigate } from "react-router-dom";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { useEffect, useState } from "react";    
import Loader from "../../../../components/loader/loader";
import { ListComponent } from "../../../../components/list/list";
import { fetchPlansService } from "../../../../features/plans/service/plan-service";
import MenuContext, { DISPLAY_TYPE } from "../../../../components/menu/context/menu-context";

// Interface para definir a tipagem dos planos
interface Plan {
    id: string;
    nome: string;
    // Adicione outras propriedades conforme seu modelo de dados
}

export function ListPlan() {
    const navigate = useNavigate();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ plans, setPlans ] = useState<any[]>([]);
    const [ error, setError ] = useState<string | null>(null);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                setIsLoading(true);
                setError(null); // Limpa erros anteriores
                const fetchedPlans = await fetchPlansService();
                setPlans(fetchedPlans);
            } catch (error) {
                console.error('Erro ao buscar planos:', error);
                setError('Não foi possível carregar os planos. Tente novamente mais tarde.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchPlans();
    }, []);

    return (
        <div className="container-plan">
            <MenuTop />
            
            {isLoading && <Loader />}
            
            <div className='container-plan__content'>
                <div className="container-plan__content__title">
                    <h1 className="container-plan__content__title-text">Listagem de planos</h1>
                    <MenuContext 
                        display={DISPLAY_TYPE.INLINE} 
                        clickedAdd={() => navigate('/plano')}
                    />
                </div>
                
                {/* Tratamento de erro */}
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}
                
                {/* Renderização condicional de planos */}
                {!error && (
                    <>
                        {plans.length > 0 ? (
                            <ListComponent 
                                data={plans} 
                                handleRedirect={(id: string) => navigate(`/plano/${id}`)}
                            />
                        ) : (
                            !isLoading && <p className="empty-message">Nenhum plano encontrado.</p>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}